/* eslint-disable header/header */
export const name = "@azure/msal-react";
export const version = "2.0.5";
//# sourceMappingURL=packageMetadata.js.map